/*
|--------------------------------------------------------------------------
| Utilities: Fetch: View
|--------------------------------------------------------------------------
*/

__gh__webApp.utilities.fetch.view = {

	/**
	 * Initialize
	 */
	"init": function() {
		this.bindEvents();
	},


	/**
	 * Get a view using url, view and dom
	 * @namespace
	 * @param {object} options
	 * @param {string} options.url - json data url to fetch
	 * @param {string} options.dom - html dom to insert data
	 * @param {string} options.view - name of handlebars view
	 * @param {boolean} [options.append] - true or false, append the data or replace it
	 * @param {string} [options.callbacks] - comma delimited list of functions to run
	 * @param {object} [options.data] - object of data to send to the view
	 * @example
	 *	<a href="#"
	 *		data-gh-fetch-view-loaded="false"
	 *		data-gh-fetch-view-view="partialSlider3Image"
	 *		data-gh-fetch-view-dom="#gh-fetch-view-{{id}}"
	 *		data-gh-fetch-view-url="{{feedURL}}"
	 *		data-gh-fetch-view-callbacks="__gh__webApp.utilities.slider.bindEvents"
	 *		data-gh-fetch-view-data='{"id":"{{id}}"}'
	 *	>{{title}}</a>
	 */
	 "get": function(options){
		var url 					= (options.url) 			? options.url 				: null,
			dom 					= (options.dom) 			? options.dom 				: null,
			view 					= (options.view) 			? options.view 				: null,
			append 					= (options.append)			? options.append			: false,
			callbacks 				= (options.callbacks)		? options.callbacks			: null,
			additionalData			= (options.data)			? options.data				: null;

		//Check variables
		if(!url){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Missing url."});
			return;
		}
		if(!dom){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Missing dom."});
			return;
		}
		if(!view){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Missing view."});
			return;
		}


		//Get JSON
		var data = {"items": __gh__webApp.utilities.fetch.json.get({"url":url})};
		if(!data.items.main){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Getting the data failed."});
			return;
		}


		//Merge data
		if (data){
			data = __gh__webApp.common.mergeObjects(data,additionalData);
		}


		//Get View
		var html = __gh__webApp.utilities.fetch.handlebarsView.get({
			"view": view,
			"data": data
		});
		if(!html){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Getting the view failed."});
			return;
		}


		//Insert Into DOM
		if(append){
			$(dom).append(html);

		}
		else{
			$(dom).html(html);
		}

		//Run callback function
		if (callbacks){
			__gh__webApp.common.callArrayOfFunctions(callbacks);
		}

	},


	/**
	 * Bind the UI events
	 */
	"bindEvents": function() {
		var fetchView = this.get;

	    $(document).on("click", "a[data-gh-fetch-view-url]", function(event){
		    event.preventDefault();
			fetchView({
				"dom"			: $(this).data("gh-fetch-view-dom"),
				"url"			: $(this).data("gh-fetch-view-url"),
				"view"			: $(this).data("gh-fetch-view-view"),
				"append"		: $(this).data("gh-fetch-view-append"),
				"callbacks"		: $(this).data("gh-fetch-view-callbacks"),
				"data"			: $(this).data("gh-fetch-view-data"),
			});
		});
  	},
};
